import { render, staticRenderFns } from "./FormSubStream.vue?vue&type=template&id=213d380f&scoped=true&"
import script from "./FormSubStream.vue?vue&type=script&lang=ts&"
export * from "./FormSubStream.vue?vue&type=script&lang=ts&"
import style0 from "./FormSubStream.vue?vue&type=style&index=0&id=213d380f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d380f",
  null
  
)

export default component.exports